import styled from '@emotion/styled';

import { hoverable, IconButton, pressable } from '@/shared/design-system';

export const ToggleButton = styled(IconButton)(({ theme }) => ({
  ...hoverable(theme, ['surfaceRaised', 'text']),
  ...pressable(theme, ['surfaceRaised', 'text']),
  height: 32,
  backgroundColor: 'transparent',
  color: theme.colors.icon.secondary,
}));
